import { createService } from '../../utils'
import { getBaseApi } from './baseApi'
import enhanceEndpoints from './enhanceApi'

const patientIntegrationsGQLService = createService(
  ({ origin, getAccessToken }) => {
    const api = getBaseApi(origin, getAccessToken)
    return enhanceEndpoints(api)
  },
)

export const  patientIntegrationsApi = patientIntegrationsGQLService({
  origin: `https://${process.env.PATIENT_INTEGRATIONS_API_DOMAIN}`,
})

export type PatientIntegrationsApiType = typeof patientIntegrationsApi
